module.exports = __webpack_public_path__ + "img/21-1.4f95ba35.png";